import React from 'react'
import { makeStyles, Toolbar, AppBar } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { UserProfileMenu } from '../../../../common-client2/src/components';

const styles = makeStyles({
    toolBar: {
        padding: 0,
    },
    appBar: {
        boxShadow: 'none',
        backgroundColor: '#FFFFFF',
        color: '#000000',
        borderBottom: '1px solid #EEEEEE',
        zIndex: 1050
    },
    userTools: {
        minWidth: 250,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
    },
});

const topBar = (props) => {
    const isStatic = props.isStatic;
    const classes = styles();
    const { t } = useTranslation('common');

    let name;
    let initials;
    let position = (isStatic) ? 'static' : 'fixed';

    if (props.person) {
        name = `${props.person.firstName} ${props.person.lastName}`;
        initials = `${props.person.firstName[0]}${props.person.lastName[0]}`;
    } else {
        name = sessionStorage.getItem('username');
        let initialsArray = name.split(' ');
        initials = initialsArray.map(word => word[0]);
    }

    return (
        <AppBar position={position} className={classes.appBar}>
            <Toolbar className={classes.toolBar} >
                {props.children}
                <div className={classes.userTools}>
                    {/* {
                        (i18n.language.includes('en')) ?
                            <Button color="inherit" onClick={() => changeLang("fr")}>FR</Button>
                            :
                            <Button color="inherit" onClick={() => changeLang("en")}>EN</Button>
                    } */}
                    <UserProfileMenu
                        initials={initials}
                        fullName={name}
                        version={props.buildInfos.version}
                        environement={t(`environment.${props.buildInfos.environment}`)}
                        labels={{
                            sectionTitleAbout: t(`userMenu.about`),
                            aboutVersion: t(`userMenu.version`),
                            aboutEnvironment: t(`userMenu.environment`)
                        }}
                    />
                </div>
            </Toolbar>
        </AppBar>
    )
}

export default topBar;